import { render, staticRenderFns } from "./GeneralArea.vue?vue&type=template&id=4b93249e&scoped=true&"
import script from "./GeneralArea.vue?vue&type=script&lang=js&"
export * from "./GeneralArea.vue?vue&type=script&lang=js&"
import style0 from "./GeneralArea.vue?vue&type=style&index=0&id=4b93249e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93249e",
  null
  
)

export default component.exports